import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newsCateList: [],
    serviceCateList: [],
    customerCateList: [],
    commemorateList: [],
    aboutCateList: [],
  },
  getters: {
  },
  mutations: {
    SET_NEWS_CATE_LIST(state, val) {
      state.newsCateList = val
    },
    SET_SERVICE_CATE_LIST(state, val) {
      state.serviceCateList = val
    },
    SET_CUSTOMER_CATE_LIST(state, val) {
      state.customerCateList = val
    },
    SET_COMMEMORATE_CATE_LIST(state, val) {
      state.commemorateList = val
    },
    SET_ABOUT_CATE_LIST(state, val) {
      state.aboutCateList = val
    }
  },
  actions: {
    setNewsCateList({commit},val) {
      commit('SET_NEWS_CATE_LIST', val)
    },
    setServiceCateList({commit},val) {
      commit('SET_SERVICE_CATE_LIST', val)
    },
    setCustomerCateList({commit},val) {
      commit('SET_CUSTOMER_CATE_LIST', val)
    },
    setCommemorateList({commit},val) {
      commit('SET_COMMEMORATE_CATE_LIST', val)
    },
    setAboutCateList({commit},val) {
      commit('SET_ABOUT_CATE_LIST', val)
    }
  },
  modules: {
  }
})
